import { Helmet } from 'react-helmet-async';
import { CONFIG } from 'src/config-global';
import LibraryMealDiscussion from 'src/sections/home/library-meal-discussion';

// ----------------------------------------------------------------------

const metadata = { title: `Meal Discussion |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <LibraryMealDiscussion />
    </>
  );
}
